var _ThemeProvider$propTy;

import React from 'react';
import PropTypes from 'prop-types';
import { PortalProvider } from '@gorhom/portal';
import A11yInfoProvider from '../A11yInfoProvider';
import ViewportProvider from '../ViewportProvider';
import ThemeProvider from '../ThemeProvider';
import { HydrationProvider } from './HydrationContext';
import { jsx as _jsx } from "react/jsx-runtime";

const BaseProvider = _ref => {
  let {
    defaultTheme,
    children,
    themeOptions
  } = _ref;
  return /*#__PURE__*/_jsx(HydrationProvider, {
    children: /*#__PURE__*/_jsx(A11yInfoProvider, {
      children: /*#__PURE__*/_jsx(ViewportProvider, {
        children: /*#__PURE__*/_jsx(ThemeProvider, {
          defaultTheme: defaultTheme,
          themeOptions: themeOptions,
          children: /*#__PURE__*/_jsx(PortalProvider, {
            children: children
          })
        })
      })
    })
  });
};

BaseProvider.propTypes = {
  children: PropTypes.node.isRequired,
  defaultTheme: (_ThemeProvider$propTy = ThemeProvider.propTypes) === null || _ThemeProvider$propTy === void 0 ? void 0 : _ThemeProvider$propTy.defaultTheme,
  themeOptions: PropTypes.shape({
    forceAbsoluteFontSizing: PropTypes.bool,
    forceZIndex: PropTypes.bool
  })
};
export default BaseProvider;